import { Select } from "antd";
import React, { useEffect } from "react";
import { useListUsersQuery } from "../redux/Api/CustomerApiSlice";
import Loader from "../pages/pages/loader";
import { toast } from "react-toastify";

const CustomersDropdown = ({
  onChange,
  onBlur,
  value,
  className = "",
  isAll = false,
}) => {
  const {
    data: customers,
    isLoading,
    error,
  } = useListUsersQuery({
    expand: ["country", "last_updated_by"].join(","),
    page: "*",
    ordering: "id",
  });

  let options;

  if (customers) {
    options = customers?.results?.map((x) => {
      return { label: x.customer_name, value: x.id };
    });
    if (isAll) {
      options = [{ label: "All Customers", value: "*" }, ...options];
    }
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat();
      errorMessages.forEach((message) => {
        toast.error(message);
      });
    }
  }, [error]);

  return (
    <div>
      <Loader isLoading={isLoading} />
      <label className="form-label">Customer</label>
      <Select
        className={className}
        name="customer"
        showSearch
        style={{
          width: "100%",
        }}
        optionFilterProp="label"
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? "")
            .toLowerCase()
            .localeCompare((optionB?.label ?? "").toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={options}
      />
    </div>
  );
};

export default CustomersDropdown;
